// extracted by mini-css-extract-plugin
export var logo = "_kt-2";
export var logoWrapper = "_kt-1";
export var strip = "_kt-0";